import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { accountGet, accountSend } from "@/lib/api";

const AuthContext = createContext(null);
const ROLE_KEY = "mat_intended_role";

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(undefined); // undefined=loading, null=guest, obj=logged
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const u = await accountGet("/account/me");
      setUser(u || null);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // If returning from Google OAuth, AuthCallback exchanges the session first.
    if (typeof window !== "undefined" && window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const login = async (email, senha) => {
    const r = await accountSend("/account/login", "POST", { email, senha });
    setUser(r.user);
    return r.user;
  };

  const register = async (payload) => {
    const r = await accountSend("/account/register", "POST", payload);
    setUser(r.user);
    return r.user;
  };

  const logout = async () => {
    try { await accountSend("/account/logout", "POST"); } catch { /* ignore */ }
    setUser(null);
  };

  const loginGoogle = (role = "familia") => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    localStorage.setItem(ROLE_KEY, role);
    const redirectUrl = window.location.origin + "/minha-conta";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, refresh, login, register, logout, loginGoogle }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
export const getIntendedRole = () => {
  const r = localStorage.getItem(ROLE_KEY) || "familia";
  return r === "fornecedor" ? "fornecedor" : "familia";
};
